import { useQuery } from "@tanstack/react-query";
import { getMe, type User } from "../../api/private/getMe";
import { useToken } from "../../contexts/TokenContext";

export const useGetMe = () => {
  const { idToken } = useToken();

  return useQuery<User, Error>({
    queryKey: ["getMe", idToken],
    queryFn: () => getMe(idToken),
    enabled: false, // don't run automatically - only when manually called
    retry: false, // don't retry on authentication errors
  });
};
